import type { EmptyStateProps } from 'owa-empty-state/lib/components/EmptyState';
import {
    getRefreshSuggestionMessage,
    getPrimaryErrorMessage,
    FailureType,
} from 'owa-calendar-load-error-message';
import { getErrorStateImage } from './getErrorStateImage';

export function getErrorEmptyStateProps(failureType: FailureType): EmptyStateProps {
    const primaryTextError = getPrimaryErrorMessage();
    const secondaryText = getRefreshSuggestionMessage(failureType);
    return {
        icon: getErrorStateImage(),
        detailMessage: secondaryText,
        mainMessage: primaryTextError,
    };
}
